import { ReactElement, useRef } from "react";
import { useSelector } from "react-redux";
import { Redirect, useLocation } from "react-router-dom";

import {
  isSignedIn,
  userHasSignedInBefore
} from "seneca-common/features/user/state";

import { isInParentPlatform } from "features/parents/links";
import { linkToSignUpParent } from "features/sign-up/links";

type Props = {
  children: ReactElement;
};

export default function SignedInRoute({ children }: Props) {
  const signedIn = useSelector(isSignedIn);
  const initiallySignedInRef = useRef(signedIn);
  const initiallySignedIn = initiallySignedInRef.current;
  const hasSignedInBefore = useSelector(userHasSignedInBefore);

  const location = useLocation();
  const { pathname, search, state } = location;

  const userHasJustSignedOut = initiallySignedIn && !signedIn;
  const newState = !userHasJustSignedOut
    ? { ...state, redirectAuthenticatedUserToLocation: location }
    : {};

  const inParentPlatform = isInParentPlatform(pathname);

  const redirectTo = getRedirectLocation({
    userHasJustSignedOut,
    hasSignedInBefore,
    inParentPlatform
  });

  return signedIn ? (
    children
  ) : (
    <Redirect
      to={{
        pathname: redirectTo,
        state: newState,
        search
      }}
    />
  );
}

function getRedirectLocation({
  userHasJustSignedOut,
  hasSignedInBefore,
  inParentPlatform
}: any) {
  if (userHasJustSignedOut || hasSignedInBefore) {
    return "/login";
  }

  if (inParentPlatform) {
    return linkToSignUpParent();
  }

  return "/sign-up";
}
